import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(()=> ({
  root: {
    maxWidth:'100%',
  },

 media:
  {
    paddingTop:'56.29%',
    marginTop:'10px',
  },
   cardActions:
   {
    display:'flex',
    justifyContent:'flex-end',
   },
   CardContent:{
    display:'flex',
    justifyContent:'space-between',
   },
}));
   


 
